module.exports = __webpack_public_path__ + "img/ic-info.205f8b60.svg";